import { render } from "./cp_XuanKe.vue?vue&type=template&id=46229e30&scoped=true"
import script from "./cp_XuanKe.vue?vue&type=script&lang=js"
export * from "./cp_XuanKe.vue?vue&type=script&lang=js"

import "./cp_XuanKe.vue?vue&type=style&index=0&id=46229e30&scoped=true&lang=css"

import exportComponent from "E:\\WorkCode\\HZYNew\\Code\\HZY.Student\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46229e30"]])

export default __exports__